import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useQuery } from "react-query";
import { getEnergyClass } from "../../../../api/geocode.api";
import { EnergyClass } from "../../../../types/geocoding.types";

export const useFormEnergyClass = ({
  onSuccess,
}: {
  onSuccess?: (data: EnergyClass | null) => void;
} = {}) => {
  const { watch } = useFormContext();

  const cityId = watch("cityId");
  const streetId = watch("streetId");
  const streetNumber = watch("streetNumber");

  const qEnergyClass = useQuery(
    ["energy_class", cityId, streetId, streetNumber],
    () => getEnergyClass(cityId, streetId, streetNumber),
    {
      enabled: !!cityId && !!streetId && !!streetNumber,
      staleTime: Infinity,
    }
  );

  useEffect(() => {
    // we dont subscribe to useQuery.onSuccess since we use staleTime: Infinity.
    // fetch value - triggers onSuccess
    // use cached value - not triggers onSuccess
    if (qEnergyClass.data) {
      onSuccess?.(qEnergyClass.data);
    }
  }, [qEnergyClass.data]);

  return qEnergyClass;
};
